module.exports = __webpack_public_path__ + "static/img/error_500.a28a365.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/error/images/error_500.png
// module id = tg1t
// module chunks = 57